/** Steps of the client-portfolio flow that exist before an import does. An open import is `importId`. */
export const CP_STEPS = ['destination', 'upload'] as const

export type ClientPortfolioStep = (typeof CP_STEPS)[number]
